<template>
  <div class="access-my-wallet-options">
    <hardware-modal
      ref="hardwareModal"
      :network-and-address-open="networkAndAddressOpen"
      @hardwareRequiresPassword="hardwarePasswordModalOpen"
      @hardwareWalletOpen="hardwareWalletOpen"
    />
    <hardware-password-modal
      ref="hardwarePasswordModal"
      :wallet-constructor="walletConstructor"
      :hardware-brand="hardwareBrand"
      @hardwareWalletOpen="hardwareWalletOpen"
    />
    <network-and-address-modal
      ref="networkandaddressModal"
      :hardware-wallet="hardwareWallet"
    />
    <software-modal
      ref="softwareModal"
      :open-password="passwordOpen"
      :open-private-key-input="privateKeyOpen"
      :open-mnemonic-phrase-input="mnemonicphraseModalOpen"
      @file="fileUploaded"
    />
    <password-modal ref="passwordModal" :file="file" />
    <private-key-modal ref="privatekeyModal" />
    <mnemonic-modal
      ref="mnemonicPhraseModal"
      :hardware-wallet-open="hardwareWalletOpen"
    />
    <wallet-password-modal />
    <enter-pin-number-modal />
    <div class="wrap">
      <div class="page-container">
        <div class="title">
          <h2>{{ $t('common.wallet.access-my') }}</h2>
          <h5>
            {{ $t('common.wallet.do-not-have') }}
            <router-link :to="'/create-wallet'" class="nounderline">
              {{ $t('common.wallet.create-new') }}
            </router-link>
          </h5>
        </div>
        <div class="buttons-container d-flex justify-content-center">
          <access-wallet-button
            v-for="(button, index) in buttons"
            :key="button.title + index"
            :func="button.func"
            :img="button.img"
            :img-disabled="button.imgDisabled"
            :title="$t(button.title)"
            :desc="$t(button.desc)"
            :recommend="$t(button.recommend)"
            :tooltip="$t(button.tooltip)"
            :disabled="button.disabled"
            :classname="button.classname"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AccessWalletButton from '../../components/AccessWalletButton';
import HardwarePasswordModal from '../../components/HardwarePasswordModal';
import HardwareModal from '../../components/HardwareModal';
import NetworkAndAddressModal from '../../components/NetworkAndAddressModal';
import PasswordModal from '../../components/PasswordModal';
import PrivateKeyModal from '../../components/PrivateKeyModal';
import SoftwareModal from '../../components/SoftwareModal';
import MnemonicModal from '../../components/MnemonicModal';
import WalletPasswordModal from '@/components/WalletPasswordModal';
import EnterPinNumberModal from '@/components/EnterPinNumberModal';
import softwareImg from '@/assets/images/icons/button-software.svg';
import softwareImgDisabled from '@/assets/images/icons/button-software-disabled.svg';

import { mapState } from 'vuex';
import { Toast } from '@/helpers';

import DetectRTC from 'detectrtc';

export default {
  components: {
    'network-and-address-modal': NetworkAndAddressModal,
    'hardware-modal': HardwareModal,
    'hardware-password-modal': HardwarePasswordModal,
    'software-modal': SoftwareModal,
    'password-modal': PasswordModal,
    'private-key-modal': PrivateKeyModal,
    'mnemonic-modal': MnemonicModal,
    'access-wallet-button': AccessWalletButton,
    'wallet-password-modal': WalletPasswordModal,
    'enter-pin-number-modal': EnterPinNumberModal
  },
  data() {
    return {
      file: {},
      phrase: '',
      hardwareWallet: {},
      hardwareAddresses: [],
      walletConstructor: function() {},
      hardwareBrand: '',
      buttons: [
        {
          func: this.softwareModalOpen,
          title: 'accessWallet.software.option-title',
          desc: 'accessWallet.software.option-text',
          tooltip: '',
          img: softwareImg,
          imgDisabled: softwareImgDisabled,
          disabled: false,
          classname: 'button-software'
        }
      ],
      isMetaMask: false,
      web3WalletExists: false
    };
  },
  computed: {
    ...mapState(['online', 'Networks'])
  },
  mounted() {
    this.$nextTick(() => {
      this.buttons.forEach(btn => {
        btn.disabled = this.isDisabled(btn.classname);
      });

      this.checkWeb3();
      this.checkIsMetamask();
    });
  },
  methods: {
    checkIsMetamask() {
      this.isMetaMask = window.ethereum && window.ethereum.isMetaMask;
    },
    checkWeb3() {
      this.web3WalletExists =
        typeof window.ethereum !== 'undefined' ||
        typeof window.web3 !== 'undefined';
    },
    isDisabled(className) {
      switch (className) {
        case 'button-mewconnect':
          return !(this.online && DetectRTC.isWebRTCSupported);
        case 'button-hardware':
          return !this.online;
        default:
          return false;
      }
    },
    mewConnectModalOpen() {
      this.$refs.mewconnectModal.$refs.mewConnect.show();
    },
    ledgerAppModalOpen() {
      this.$refs.ledgerAppModal.$refs.ledgerApp.show();
    },
    networkAndAddressOpen() {
      this.$refs.networkandaddressModal.$refs.networkAndAddress.show();
    },
    hardwareModalOpen() {
      this.$refs.hardwareModal.$refs.hardware.show();
    },
    web3WalletModal() {
      this.checkWeb3();
      this.checkIsMetamask();
      this.$refs.metamaskModal.$refs.metamask.show();
    },
    softwareModalOpen() {
      this.$refs.softwareModal.$refs.software.show();
    },
    passwordOpen() {
      this.$refs.softwareModal.$refs.software.hide();
      this.$refs.passwordModal.$refs.password.show();
    },
    privateKeyOpen() {
      this.$refs.softwareModal.$refs.software.hide();
      this.$refs.privatekeyModal.$refs.privateKey.show();
    },
    installWeb3WalletModalOpen() {
      this.$refs.installWeb3WalletModal.$refs.installmetamask.show();
    },
    mnemonicphraseModalOpen() {
      this.$refs.mnemonicPhraseModal.$refs.mnemonicPhrase.show();
      this.$refs.softwareModal.$refs.software.hide();
    },
    // mnemonicphrasePasswordModalOpen(phrase) {
    //   this.phrase = phrase;
    //   this.$refs.mnemonicPhraseModal.$refs.mnemonicPhrase.hide();
    //   this.$refs.mnemonicPhrasePassword.$refs.password.show();
    // },
    fileUploaded(e) {
      this.file = e;
      this.passwordOpen();
    },
    hardwarePasswordModalOpen(hardwareNeedingPassword) {
      this.walletConstructor = hardwareNeedingPassword.walletConstructor;
      this.hardwareBrand = hardwareNeedingPassword.hardwareBrand;
      this.$refs.hardwareModal.$refs.hardware.hide();
      this.$refs.hardwarePasswordModal.$refs.password.show();
    },
    finneyModalOpen() {
      this.$refs.finney.$refs.finneyModal.show();
    },
    xwalletModalOpen() {
      this.$refs.xwallet.$refs.xwalletModal.show();
    },
    hardwareWalletOpen(wallet) {
      // if (this.$refs.mnemonicPhrasePassword.$refs.password.visible) {
      //   this.$refs.mnemonicPhrasePassword.$refs.password.hide();
      // }
      try {
        this.hardwareWallet = wallet;
        this.networkAndAddressOpen();
      } catch (e) {
        Toast.responseHandler(e, false);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'AccessMyWalletContainer-desktop.scss';
@import 'AccessMyWalletContainer-tablet.scss';
@import 'AccessMyWalletContainer-mobile.scss';
</style>
